module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-noneheader"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("系统配置")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/config/configList'
      }
    }
  }, [_vm._v("配置列表")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("配置录入")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "width": "auto",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "form-default",
    attrs: {
      "model": _vm.config,
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.config.id),
      callback: function($$v) {
        _vm.$set(_vm.config, "id", $$v)
      },
      expression: "config.id"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置分类"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.config.category),
      callback: function($$v) {
        _vm.$set(_vm.config, "category", $$v)
      },
      expression: "config.category"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置分类说明"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.config.categoryLabel),
      callback: function($$v) {
        _vm.$set(_vm.config, "categoryLabel", $$v)
      },
      expression: "config.categoryLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置介绍"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.config.configLabel),
      callback: function($$v) {
        _vm.$set(_vm.config, "configLabel", $$v)
      },
      expression: "config.configLabel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置值类型"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.config.valueType),
      callback: function($$v) {
        _vm.$set(_vm.config, "valueType", $$v)
      },
      expression: "config.valueType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置KEY"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.config.configKey),
      callback: function($$v) {
        _vm.$set(_vm.config, "configKey", $$v)
      },
      expression: "config.configKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置VALUE"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "true"
    },
    model: {
      value: (_vm.config.value),
      callback: function($$v) {
        _vm.$set(_vm.config, "value", $$v)
      },
      expression: "config.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65d37204!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/system/ConfigModify.vue
// module id = 457
// module chunks = 2